import List from 'notifications/List'

export default {
  List,
}
